import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
export function getMilestoneInteractionsByType(layoutElement, type) {
    return [
        layoutElement.milestone_interaction
    ].concat(_to_consumable_array(layoutElement.milestone_interactions || [])).map(function(i) {
        var _i_user_milestone;
        return (i === null || i === void 0 ? void 0 : i.type) === type ? i === null || i === void 0 ? void 0 : (_i_user_milestone = i.user_milestone) === null || _i_user_milestone === void 0 ? void 0 : _i_user_milestone.retailer_milestone : undefined;
    }).filter(isNotUndefined);
}
